import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-lobby" }
const _hoisted_2 = { class: "settings" }
const _hoisted_3 = { class: "settings_field players" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "settings_field_label" }, "Players", -1)
const _hoisted_5 = { class: "settings_field rounds" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "settings_field_label" }, "Rounds", -1)
const _hoisted_7 = { class: "settings_field draw-time" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "settings_field_label" }, "Draw time", -1)
const _hoisted_9 = { class: "settings_field invite" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Invite Id ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "invite_input" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "settings_field start" }
const _hoisted_16 = { class: "chat" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_player_icons = _resolveComponent("player-icons")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_chat = _resolveComponent("chat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_player_icons, {
          players: _ctx.game.players
        }, null, 8, ["players"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_dropdown, {
          class: _normalizeClass({ disabled: !_ctx.isClientGameCreator }),
          selectedItem: _ctx.game.rounds,
          items: _ctx.roundSelections,
          onSelectedItem: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('rounds-update', $event)))
        }, null, 8, ["class", "selectedItem", "items"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_dropdown, {
          class: _normalizeClass({ disabled: !_ctx.isClientGameCreator }),
          selectedItem: _ctx.game.drawTime,
          items: _ctx.drawTimeSelections,
          onSelectedItem: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('draw-time-update', $event)))
        }, null, 8, ["class", "selectedItem", "items"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", {
          class: "settings_field_label",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyInviteId())),
          tabindex: "0"
        }, _hoisted_12),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("input", {
            type: "text",
            value: _ctx.route.params.id,
            readonly: ""
          }, null, 8, _hoisted_14)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('start-game'))),
          class: _normalizeClass(["btn", { disabled: !_ctx.canStartGame }])
        }, " Start Game ", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_chat, {
        messages: _ctx.game.messages,
        onSendMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('send-message', $event)))
      }, null, 8, ["messages"])
    ])
  ]))
}